var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCarSharing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-Rides-1",
    transform: "translate(-21.000000, -484.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 466.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_carsharing_inactive",
    transform: "translate(20.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.64,12.42 L2.01,11.75",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,15.9 L14.4,15.9",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75,14.9 L6.75,14.9",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.05,14.9 L20.05,14.9",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 1.5,
    points: "20.05 13.31 20.05 20.6 19.65 20.6 17.09 20.6 17.1 18.96 11.4 18.96 5.73 18.96 5.7 20.6 3.15 20.6 2.75 20.6 2.75 13.69 4.64 12.43 6.63 8.55 9.64 8.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64,12.42 L12.27,12.42",
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FF5F00",
    strokeWidth: 1.5,
    cx: 16.93,
    cy: 6.41,
    r: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    stroke: "#FF5F00",
    strokeWidth: 1.5,
    points: "16.93 3.07 16.93 6.41 18.59 8.07"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCarSharing);
export default __webpack_public_path__ + "static/media/ico_carSharing.65c4e6b8ffd9b8ba8d05e80910590c81.svg";
export { ForwardRef as ReactComponent };